<template>
  <div class="container">
    <!-- 政策信息 -->
    <section class="policy_mess">
      <h2>{{data.title}}</h2>
      <section class="date_box">
        <p>{{data.createTime | timeType}}</p>
        <img @click="shareFun" src="../../assets/images/icon_share.png" />
      </section>
      <section class="item_bottom_labal">
        <span v-for="item in data.tagName" :key="item"># {{item}}</span>
      </section>
    </section>
    <!-- file -->
    <section class="file_mess">
      <section class="file_item border-bottom" @click="toFileList" v-if="data.sysPolicyFileOutPut">
        <img class="file_icon" src="../../assets/images/icon_attachment.png" />
        <p>附件:{{data.sysPolicyFileOutPut.length}}</p>
        <img class="arrow_icon" src="../../assets/images/icon_indicator_next.png" />
      </section>
      <section class="file_item border-bottom" @click="toLink(data.url)" v-if="data.url">
        <p>政策链接: {{data.url}}</p>
        <img class="arrow_icon" src="../../assets/images/icon_indicator_next.png" />
      </section>
    </section>
    <!-- 富文本 -->
    <section class="viewhtml" v-html="data.content"></section>
    <section class="footer_h"></section>
    <section class="button footer_box" @click="comsultation" v-if="data.isConsultation">
      <p class="btn_default">咨询</p>
    </section>
    <share-iframe :showIframe="showIframe" @hideIframe="hideIframe"></share-iframe>
  </div>
</template>

<script>
import ShareIframe from "../../components/shareIframe";
import wx from "weixin-js-sdk";
//import wx from 'jweixin-1.6.0'
import util from "../../utils/util";
import { gePolicyDetail } from "../../utils/api";
import { mapState } from "vuex";
export default {
  name: "policyDetail",
  data() {
    return {
      richText: "12233",
      showIframe: false,
      id: "",
      data: {}
    };
  },
  components: {
    ShareIframe
  },
  filters: {
    timeType(val) {
      return util.formatTime(new Date(Number(val)), 4);
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.gePolicyDetail();
  },
  methods: {
    gePolicyDetail() {
      let that = this;
      util.showLoading();
      gePolicyDetail({ id: this.$route.query.id }).then(res => {
        console.log(res);
        if (res.res.code === 10000 && res.body.policy) {
          let data = res.body.policy;
          if (data.tagName) {
            data.tagName = data.tagName.split(/[\s+,，]/g)
          }
          this.data = data;
          let address = window.location.href.split('?')[0];
          wx.ready(() => {
            let obj = {
              title: this.data.title, // 分享标题
              desc: this.data.typeNames,
              link: address + '?id=' + this.$route.query.id + "&marketId=" + this.common.marketInfo.id + '&cityId=' + this.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "https://rst.vanke.com/rststatic/other/policy.jpg", // 分享图标
              success: function () {
                that.showIframe = false;
                util.showToast('已分享')
              }
            };
            wx.onMenuShareAppMessage(obj);
            wx.onMenuShareTimeline(obj);
          });
        } else {
          util.showToast(res.res.msg);
        }
        util.hideLoading();
      });
    },
    toSearch() {
      this.$router.push("/policySearch");
    },
    shareFun() {
      this.showIframe = true;
    },
    hideIframe() {
      this.showIframe = false;
    },
    toFileList() {
      localStorage.setItem(
        "fileList",
        JSON.stringify(this.data.sysPolicyFileOutPut)
      );
      var url = '/fileList?time=' + this.data.createTime + "&cityId=" + this.common.cityId
      this.$router.push(url)
      // this.$router.push(`/fileList?time=${this.data.createTime}`);
    },
    comsultation() {
      if (this.common.userId) {
        this.$router.push(
          `/comsultationForm/${this.data.typeId}/${this.data.id}`
        );
      } else {
        this.$router.push({
          path: "/login",
          query: {
            Rurl: `/comsultationForm/${this.data.typeId}/${this.data.id}`
          }
        });
      }
    },
    toLink(url) {
      localStorage.setItem("src", url);
      // 跳转地址
      this.$router.push(`/iframePage`);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.policy_mess {
  padding: 28px 28px 18px;
  h2 {
    padding-right: 64px;
    font-size: 44px;
    font-weight: bold;
    color: rgba(24, 24, 24, 1);
    line-height: 60px;
    margin-bottom: 10px;
  }
  .date_box {
    .flex();
    height: 44px;
    margin-bottom: 22px;
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 28px;
      color: rgba(153, 153, 153, 1);
    }
    img {
      display: block;
      width: 44px;
      height: 44px;
      padding-left: 40px;
    }
  }
  .item_bottom_labal {
    .flex();
    padding-right: 64px;
    span {
      display: block;
      margin-right: 10px;
      margin-bottom: 10px;
      // min-width: 160px;
      padding: 0 10px;
      background: rgba(235, 239, 245, 1);
      border-radius: 4px;
      font-size: 24px;
      color: rgba(60, 100, 159, 1);
      line-height: 34px;
      text-align: center;
    }
  }
}
// file
.file_mess {
  padding: 0 28px;
  .file_item {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 80px;
    .file_icon {
      display: block;
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    p {
      flex: 1;
      .textOver(100%);
      height: 80px;
      line-height: 80px;
      font-size: 28px;
      color: #333;
    }
    .arrow_icon {
      display: block;
      width: 32px;
      height: 32px;
    }
  }
}
.footer_h {
  height: 108px;
  width: 100%;
}
.footer_box {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 108px;
  padding: 0 28px;
  background: #fff;
  box-sizing: border-box;
  .flex();
  align-items: center;
  justify-content: center;
  p {
    height: 76px;
    background: rgba(23, 64, 218, 1);
    border-radius: 4px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 76px;
    display: block;
    width: 100%;
    text-align: center;
  }
}
.viewhtml {
  padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>